export default __webpack_public_path__ + "static/media/CL11.8d0db094.mp3";